import { PermissaoEnum } from 'resources/enums/permissao';
import { checkPermission } from 'infra/helpers/permission';
import { TipoTenantEnum } from 'resources/enums/tenant';
import { useCurrentTenant } from 'core/features/auth/tenant.store';
import {
  TipoDocumentoEnum,
  TipoEntidadeEnum,
} from "core/resources/enums/conta";
import { OperacaoEnum } from "core/resources/enums/conta";

export function mapTipoEntidadeToLabel(
  tipoEntidade?: TipoEntidadeEnum,
  operacao?: OperacaoEnum
): string {
  if (!tipoEntidade) {
    return operacao === OperacaoEnum.Receita ? "Devedor" : "Recebedor";
  }

  const map = {
    [TipoEntidadeEnum.Fornecedor]: "Fornecedor",
    [TipoEntidadeEnum.Cliente]: "Cliente",
    [TipoEntidadeEnum.Funcionario]: "Funcionário",
    [TipoEntidadeEnum.OrgaoPublico]: 'Orgão Publico',
    // [TipoEntidadeEnum.Transportadora]: "Transportadora",
    [TipoEntidadeEnum.Condomino]: "Condômino",
    [TipoEntidadeEnum.Outros]: "Outros",
  };

  return map[tipoEntidade] || "Pessoa";
}

export function useOptionsTipoEntidade() {
  const { tenant } = useCurrentTenant();
  const options = [];

  options.push({
    label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Fornecedor),
    value: TipoEntidadeEnum.Fornecedor,
  });

  if (tenant.tipoTenantId === TipoTenantEnum.Condominio) {
    options.push({
      label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Condomino),
      value: TipoEntidadeEnum.Condomino,
    })
  }

  if (checkPermission(PermissaoEnum.Backoffice.Administrativo.Cliente.Visualizar)) {
    options.push({
      label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Cliente),
      value: TipoEntidadeEnum.Cliente,
    });
  }

  return options;
}

export function getOptionsTipoEntidade() {
  return [
    {
      label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Fornecedor),
      value: TipoEntidadeEnum.Fornecedor,
    },
    // {
    //   label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Cliente),
    //   value: TipoEntidadeEnum.Cliente,
    // },
    // {
    //   label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Funcionario),
    //   value: TipoEntidadeEnum.Funcionario,
    // },
    // {
    //   label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Transportadora),
    //   value: TipoEntidadeEnum.Transportadora,
    // },
    {
      label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Condomino),
      value: TipoEntidadeEnum.Condomino,
    },
    // {
    //   label: mapTipoEntidadeToLabel(TipoEntidadeEnum.Outros),
    //   value: TipoEntidadeEnum.Outros,
    // },
  ];
}

export function mapTipoDocumentoToLabel(
  tipoDocumento?: TipoDocumentoEnum
): string {
  if (!tipoDocumento) return "--";
  const map = {
    [TipoDocumentoEnum.NotaFiscal]: "Nota Fiscal",
    [TipoDocumentoEnum.NFE]: "Nota Fiscal Eletrônica",
    [TipoDocumentoEnum.Fatura]: "Fatura",
    [TipoDocumentoEnum.Recibo]: "Recibo",
    [TipoDocumentoEnum.CupomFiscal]: "Cupom Fiscal",
    [TipoDocumentoEnum.Outros]: "Outros",
  };

  return map[tipoDocumento];
}

export function getOptionsTipoDocumento() {
  return [
    {
      label: mapTipoDocumentoToLabel(TipoDocumentoEnum.NotaFiscal),
      value: TipoDocumentoEnum.NotaFiscal,
    },
    {
      label: mapTipoDocumentoToLabel(TipoDocumentoEnum.NFE),
      value: TipoDocumentoEnum.NFE,
    },
    {
      label: mapTipoDocumentoToLabel(TipoDocumentoEnum.Fatura),
      value: TipoDocumentoEnum.Fatura,
    },
    {
      label: mapTipoDocumentoToLabel(TipoDocumentoEnum.Recibo),
      value: TipoDocumentoEnum.Recibo,
    },
    {
      label: mapTipoDocumentoToLabel(TipoDocumentoEnum.CupomFiscal),
      value: TipoDocumentoEnum.CupomFiscal,
    },
    {
      label: mapTipoDocumentoToLabel(TipoDocumentoEnum.Outros),
      value: TipoDocumentoEnum.Outros,
    },
  ];
}
